import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Cotización from "../components/Cotización";
// import Testimonios from "../components/Testimonios"; // Reseñas pausadas temporalmente.
import Footer from "../components/Footer";
import ButtonWhatsapp from "../components/ButtonWhatsapp";
import NavbarLogo from "../components/NavbarLogo";
export default function Home() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const [showSpinner, setShowSpinner] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowSpinner(false);
    }, 1);

    return () => clearTimeout(timeout); // Limpieza del timeout
  }, []);
  return (
    <div>
      {showSpinner && (
        <div id="spinner"  class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
          {/* Aquí puedes personalizar el spinner */}
          <div class="spinner"></div>
        </div>
      )}

      <div className="container-fluid bg-primary px-5 d-none d-lg-block">
        <div className="row gx-0">
          <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: "45px" }}
            >
              <a
               href="https://wa.me/+541161361408?text=¡Hola!%20Quisiera%20más%20información%20sobre%20tus%20servicios%20de%20desarrollo%20web%20y%20aplicaciones."
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="me-3 text-light">
                  <i
                    className="bi bi-whatsapp me-2"
                    style={{ color: "white" }}
                  ></i>
                  +54 11 6136 1408
                </small>
              </a>
              <a
                href="tel:+541161361408"
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="me-3 text-light">
                  <i className="fa fa-phone-alt me-2"></i>+54 11 6136 1408
                </small>
              </a>
              <a
                href="mailto:info@elaritech.com"
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="text-light">
                  <i className="fa fa-envelope-open me-2"></i>info@elaritech.com
                </small>
              </a>
            </div>
          </div>
          <div className="col-lg-4 text-center text-lg-end">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: "45px" }}
            >
              {/*    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-twitter fw-normal"></i></a> */}
              <a
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                href="https://www.facebook.com/profile.php?id=61572272330417"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f fw-normal"></i>
              </a>
              {/*                     <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-linkedin-in fw-normal"></i></a>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-instagram fw-normal"></i></a>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle" href=""><i className="fab fa-youtube fw-normal"></i></a> */}
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid position-relative p-0">
        <nav className="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0">
          <NavbarLogo />

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="fa fa-bars"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">
              <Link to="/" className="nav-item nav-link active">
                Inicio
              </Link>
              <Link to="/sobre-nosotros" className="nav-item nav-link">
                Sobre Nosotros
              </Link>
              <Link to="/nuestros-servicios" className="nav-item nav-link">
                Servicios
              </Link>

              <Link to="/contáctanos" className="nav-item nav-link">
                Contáctanos
              </Link>
            </div>
            <Link
              to="/cotización"
              class="btn btn-primary py-2 px-4 ms-3"
            >
              Solicitar Cotización
            </Link>
          </div>
        </nav>

        <div
          id="header-carousel"
          className="carousel slide carousel-fade"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img
                className="w-100"
                src={require("../img/bg-slide.webp")}
                alt="Desarrollo de soluciones web, móviles y Smart TV a medida"
              />
              <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                <div className="p-3" style={{ maxWidth: "900px" }}>
                  <h5 className="text-white text-uppercase mb-3 animated slideInDown">
                    Desarrollo Personalizado
                  </h5>
                  <h1 className="display-1 text-white mb-md-4 animated zoomIn">
                    Desarrollo web, aplicaciones móviles y Smart TV
                  </h1>
                  <p className="text-white mb-4 animated fadeIn">
                    En <strong>ELARITECH</strong> ofrecemos servicios de
                    desarrollo a medida para todas las plataformas, asegurando
                    innovación y calidad en cada proyecto.
                  </p>
                  <Link
                    to="/cotización"
                    className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft"
                  >
                    Solicitar Cotización
                  </Link>
                  <Link to="/contáctanos"
                  
                    className="btn btn-outline-light py-md-3 px-md-5 animated slideInRight"
                  >
                    Contáctanos
                  </Link>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <img
                className="w-100"
                src={require("../img/bg-slide2.webp")}
                alt="Soluciones digitales de ELARITECH para negocios"
              />
              <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                <div className="p-3" style={{ maxWidth: "900px" }}>
                  <h5 className="text-white text-uppercase mb-3 animated slideInDown">
                    Innovación y Tecnología
                  </h5>
                  <h2 className="display-1 text-white mb-md-4 animated zoomIn">
                    Impulsa tu Negocio con Nuestras Soluciones
                  </h2>
                  <p className="text-white mb-4 animated fadeIn">
                    Ya sea para una página web moderna, una app móvil intuitiva
                    o una experiencia en TV, te ayudamos a destacar en el mundo
                    digital.
                  </p>
                  <Link
                    to="/nuestros-servicios"
                    className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft"
                  >
                    Ver Servicios
                  </Link>
                  <Link
                    to="/sobre-nosotros"
                    className="btn btn-outline-light py-md-3 px-md-5 animated slideInRight"
                  >
                    Conoce Más
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#header-carousel"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Anterior</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#header-carousel"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Siguiente</span>
          </button>
        </div>
      </div>

      <div className="modal fade" id="searchModal" tabindex="-1">
        <div className="modal-dialog modal-fullscreen">
          <div
            className="modal-content"
            style={{ background: "rgba(9, 30, 62, .7)" }}
          >
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn bg-white btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body d-flex align-items-center justify-content-center">
              <div className="input-group" style={{ maxWidth: "600px" }}>
                <input
                  type="text"
                  className="form-control bg-transparent border-primary p-3"
                  placeholder="Type search keyword"
                />
                <button className="btn btn-primary px-4">
                  <i className="bi bi-search"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid facts  pt-lg-0">
        <div className="container py-5 pt-lg-0">
          <div className="row gx-0 justify-content-center">
            {" "}
            {/* Centra las columnas horizontalmente */}
            <div className="col-lg-4 wow zoomIn" data-wow-delay="0.1s">
              <div
                className="bg-primary shadow d-flex align-items-center justify-content-center p-4"
                style={{ height: "150px" }}
              >
                <div
                  className="bg-white d-flex align-items-center justify-content-center rounded mb-2"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="fa fa-users text-primary"></i>
                </div>
                <div className="ps-4">
                  <h5 className="text-white mb-0">Clientes felices</h5>
                  <p className="h1 text-white mb-0" data-toggle="counter-up">
                    +100
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 wow zoomIn" data-wow-delay="0.3s">
              <div
                className="bg-light shadow d-flex align-items-center justify-content-center p-4"
                style={{ height: "150px" }}
              >
                <div
                  className="bg-primary d-flex align-items-center justify-content-center rounded mb-2"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="fa fa-check text-white"></i>
                </div>
                <div className="ps-4">
                  <h5 className="text-primary mb-0">Proyectos realizados</h5>
                  <p className="h1 mb-0" data-toggle="counter-up">
                    +100
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid  wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-7">
              <div className="section-title position-relative pb-3 mb-5">
                <h5 className="fw-bold text-primary text-uppercase">
                  Sobre Nosotros
                </h5>
                <h2 className="h1 mb-0">
                  La Mejor Solución IT con Más de 3 Años de Experiencia
                </h2>
              </div>
              <p className="mb-4">
                En <strong>ELARITECH</strong>, contamos con más de 3 años de
                experiencia brindando soluciones innovadoras en desarrollo web,
                móvil y de televisión. Durante este tiempo, hemos trabajado con
                una amplia variedad de clientes, ayudándolos a transformar sus
                ideas en productos digitales exitosos. Nos apasiona crear
                soluciones personalizadas que se adapten a las necesidades
                específicas de cada uno de nuestros clientes.
              </p>
              <div className="row g-0 mb-3">
                <div className="col-sm-6 wow zoomIn" data-wow-delay="0.2s">
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>Soluciones
                    Personalizadas
                  </h5>
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>Equipo
                    Profesional
                  </h5>
                </div>
                <div className="col-sm-6 wow zoomIn" data-wow-delay="0.4s">
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>Soporte
                    24/7
                  </h5>
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>Compromiso
                    con la Calidad
                  </h5>
                </div>
              </div>

              <div
                className="d-flex align-items-center mb-4 wow fadeIn"
                data-wow-delay="0.6s"
              >
                <div
                  className="bg-primary d-flex align-items-center justify-content-center rounded"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="fa fa-phone-alt text-white"></i>
                </div>
                <div className="ps-4">
                  <h5 className="mb-2">Llámanos para cualquier pregunta</h5>
                  <h4 className="text-primary mb-0">+54 11 6136 1408</h4>
                </div>
              </div>
            
                  <Link
              to="/cotización"
             className="btn btn-primary py-3 px-5 mt-3 wow zoomIn"
            >
              Solicitar Cotización
            </Link>
            </div>
            <div className="col-lg-5" style={{ minHeight: "500px" }}>
              <div className="position-relative h-100">
                <img
                  className="position-absolute w-100 h-100 rounded wow zoomIn"
                  data-wow-delay="0.9s"
                  src={require("../img/equipo.webp")}
                  alt="Colaboración en un proyecto de desarrollo digital"
                  loading="lazy"
                  decoding="async"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid  wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div
            className="section-title text-center position-relative pb-3 mb-5 mx-auto"
            style={{ maxWidth: "600px" }}
          >
            <h5 className="fw-bold text-primary text-uppercase">
              ¿Por Qué Elegirnos?
            </h5>
            <h2 className="h1 mb-0">
              Estamos Aquí Para Hacer Crecer Tu Negocio Exponencialmente
            </h2>
          </div>
          <div className="row g-5">
            <div className="col-lg-4">
              <div className="row g-5">
                <div className="col-12 wow zoomIn" data-wow-delay="0.2s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fa fa-cubes text-white"></i>
                  </div>
                  <h4>Los Mejores en la Industria</h4>
                  <p className="mb-0">
                    Nos especializamos en crear soluciones innovadoras y
                    personalizadas para empresas de todos los tamaños.
                  </p>
                </div>
                <div className="col-12 wow zoomIn" data-wow-delay="0.6s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fa fa-users-cog text-white"></i>
                  </div>
                  <h4>Equipo de Expertos</h4>
                  <p className="mb-0">
                    Nuestro equipo de profesionales es altamente calificado y
                    experimentado en el desarrollo de soluciones tecnológicas de
                    vanguardia en web, móvil y TV.
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 wow zoomIn"
              data-wow-delay="0.9s"
              style={{ minHeight: "350px" }}
            >
              <div className="position-relative h-100">
                <img
                  className="position-absolute w-100 h-100 rounded wow zoomIn"
                  data-wow-delay="0.1s"
                  src={require("../img/diverse.webp")}
                  alt="Equipo colaborando en soluciones tecnológicas"
                  loading="lazy"
                  decoding="async"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="row g-5">
                <div className="col-12 wow zoomIn" data-wow-delay="0.4s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fa fa-check-circle text-white"></i>
                  </div>
                  <h4>Historial Comprobado</h4>
                  <p className="mb-0">
                    Con más de 3 años de experiencia, hemos ayudado a empresas a
                    escalar y prosperar mediante soluciones tecnológicas
                    innovadoras.
                  </p>
                </div>
                <div className="col-12 wow zoomIn" data-wow-delay="0.8s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fa fa-phone-alt text-white"></i>
                  </div>
                  <h4>Soporte 24/7</h4>
                  <p className="mb-0">
                    Ofrecemos soporte continuo para asegurar que tu negocio
                    funcione sin interrupciones en todo momento.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div
            className="section-title text-center position-relative pb-3 mb-5 mx-auto"
            style={{ maxWidth: "600px" }}
          >
            <h5 className="fw-bold text-primary text-uppercase">
              Nuestros Servicios
            </h5>
            <h2 className="h1 mb-0">
              Soluciones Innovadoras por{" "}
              <strong style={{ color: "#1976d2" }}>ELARITECH</strong>
            </h2>
          </div>
          <div className="row g-5">
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
              <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                <div className="service-icon">
                  <i className="fa fa-mobile-alt text-white"></i>
                </div>
                <h4 className="mb-3">Desarrollo de Apps</h4>
                <p className="m-0">
                  Creamos aplicaciones móviles personalizadas y optimizadas para
                  tu negocio.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
              <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                <div className="service-icon">
                  <i className="fa fa-tv text-white"></i>
                </div>
                <h4 className="mb-3">Desarrollo para Smart TV</h4>
                <p className="m-0">
                  Desarrollamos soluciones para plataformas de TV, llevando tu
                  contenido al siguiente nivel.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
              <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                <div className="service-icon">
                  <i className="fa fa-laptop-code text-white"></i>
                </div>
                <h4 className="mb-3">Desarrollo Web</h4>
                <p className="m-0">
                  Construimos sitios y plataformas web a medida con un diseño
                  moderno y funcional.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
              <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                <div className="service-icon">
                  <i className="fa fa-cogs text-white"></i>
                </div>
                <h4 className="mb-3">Soluciones IT Personalizadas</h4>
                <p className="m-0">
                  Optimizamos tus procesos tecnológicos para garantizar el éxito
                  de tu negocio.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
              <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                <div className="service-icon">
                  <i className="fa fa-search text-white"></i>
                </div>
                <h4 className="mb-3">Optimización SEO</h4>
                <p className="m-0">
                  Posicionamos tu negocio en motores de búsqueda para llegar a
                  más clientes.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
              <div className="position-relative bg-primary rounded h-100 d-flex flex-column align-items-center justify-content-center text-center p-5">
                <h3 className="text-white mb-3">¡Contáctanos!</h3>
                <p className="text-white mb-3">
                  Transforma tu idea en una realidad con nuestras soluciones
                  tecnológicas.
                </p>
                <h2 className="text-white mb-0">
                  <a
                    href="https://wa.me/+541161361408"
                    className="text-white"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    +54 11 6136 1408
                  </a>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*   <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
            <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{maxWidth: "600px"}}>
                <h5 className="fw-bold text-primary text-uppercase">Pricing Plans</h5>
                <h1 className="mb-0">We are Offering Competitive Prices for Our Clients</h1>
            </div>
            <div className="row g-0">
                <div className="col-lg-4 wow slideInUp" data-wow-delay="0.6s">
                    <div className="bg-light rounded">
                        <div className="border-bottom py-4 px-5 mb-4">
                            <h4 className="text-primary mb-1">Basic Plan</h4>
                            <small className="text-uppercase">For Small Size Business</small>
                        </div>
                        <div className="p-5 pt-0">
                            <h1 className="display-5 mb-3">
                                <small className="align-top" style={{fontSize: "22px", lineHeight: "45px" }}>$</small>49.00<small
                                    className="align-bottom" style={{fontSize: "16px", lineHeight: "40px" }}>/ Month</small>
                            </h1>
                            <div className="d-flex justify-content-between mb-3"><span>HTML5 & CSS3</span><i className="fa fa-check text-primary pt-1"></i></div>
                            <div className="d-flex justify-content-between mb-3"><span>Bootstrap v5</span><i className="fa fa-check text-primary pt-1"></i></div>
                            <div className="d-flex justify-content-between mb-3"><span>Responsive Layout</span><i className="fa fa-times text-danger pt-1"></i></div>
                            <div className="d-flex justify-content-between mb-2"><span>Cross-browser Support</span><i className="fa fa-times text-danger pt-1"></i></div>
                            <a href="" className="btn btn-primary py-2 px-4 mt-4">Order Now</a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 wow slideInUp" data-wow-delay="0.3s">
                    <div className="bg-white rounded shadow position-relative" style={{zIndex: "1"}}>
                        <div className="border-bottom py-4 px-5 mb-4">
                            <h4 className="text-primary mb-1">Standard Plan</h4>
                            <small className="text-uppercase">For Medium Size Business</small>
                        </div>
                        <div className="p-5 pt-0">
                            <h1 className="display-5 mb-3">
                                <small className="align-top" style={{fontSize: "22px", lineHeight: "45px" }}>$</small>99.00<small
                                    className="align-bottom" style={{fontSize: "16px", lineHeight: "40px" }}>/ Month</small>
                            </h1>
                            <div className="d-flex justify-content-between mb-3"><span>HTML5 & CSS3</span><i className="fa fa-check text-primary pt-1"></i></div>
                            <div className="d-flex justify-content-between mb-3"><span>Bootstrap v5</span><i className="fa fa-check text-primary pt-1"></i></div>
                            <div className="d-flex justify-content-between mb-3"><span>Responsive Layout</span><i className="fa fa-check text-primary pt-1"></i></div>
                            <div className="d-flex justify-content-between mb-2"><span>Cross-browser Support</span><i className="fa fa-times text-danger pt-1"></i></div>
                            <a href="" className="btn btn-primary py-2 px-4 mt-4">Order Now</a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 wow slideInUp" data-wow-delay="0.9s">
                    <div className="bg-light rounded">
                        <div className="border-bottom py-4 px-5 mb-4">
                            <h4 className="text-primary mb-1">Advanced Plan</h4>
                            <small className="text-uppercase">For Large Size Business</small>
                        </div>
                        <div className="p-5 pt-0">
                            <h1 className="display-5 mb-3">
                                <small className="align-top" style={{fontSize: "22px", lineHeight: "45px" }}>$</small>149.00<small
                                    className="align-bottom" style={{fontSize: "16px", lineHeight: "40px" }}>/ Month</small>
                            </h1>
                            <div className="d-flex justify-content-between mb-3"><span>HTML5 & CSS3</span><i className="fa fa-check text-primary pt-1"></i></div>
                            <div className="d-flex justify-content-between mb-3"><span>Bootstrap v5</span><i className="fa fa-check text-primary pt-1"></i></div>
                            <div className="d-flex justify-content-between mb-3"><span>Responsive Layout</span><i className="fa fa-check text-primary pt-1"></i></div>
                            <div className="d-flex justify-content-between mb-2"><span>Cross-browser Support</span><i className="fa fa-check text-primary pt-1"></i></div>
                            <a href="" className="btn btn-primary py-2 px-4 mt-4">Order Now</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
 */}

      <Cotización />

      {/* Reseñas pausadas temporalmente: <Testimonios /> */}

      <Footer />

  <ButtonWhatsapp/>
    </div>
  );
}
